import React, { useEffect, useState } from "react";
import "../../../assets/css/BlogSub-1.css";
import Blog_one from "../../../assets/image/Blog/blog-sub-1.jpg";
import BlogSubOne from "../../../assets/image/Blog/blog-sub-1.jpg";
import { Container, Card, Row, Col, Button, Image } from "react-bootstrap";
import { MdOutlinePlayCircleFilled } from "react-icons/md";
import { Form, InputGroup, ListGroup } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import { TiArrowRight } from "react-icons/ti";
import BlogPost from "../../../assets/image/Blog/blog-post.jpg";
import { FaArrowRight } from "react-icons/fa6";
import BlogSubTwo from "../../../assets/image/Blog/blog-sub-2.jpg";
import BlogSubThree from "../../../assets/image/Blog/blog-sub-3.jpg";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import Footer from "../../Footer/Footer";
import { Dropdown } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";
import data from "../../../Meta/Meta_ApiUrl";

const BlogSub_1 = () => {
  const [meta, setMeta] = useState({});


  useEffect(() => {
    // Directly access about_page from data
    const BlogMeta = data[0]?.blog_page_subpage1;

    // Set meta state if about Meta exists
    if (BlogMeta) {
      setMeta(BlogMeta);
    }
  }, []);
  const Navigation = useNavigate();
  const navigatePage = () => {
    Navigation("/blogsub_1");
  };
  // Recent post
  const recentPosts = [
    {
      id: 1,
      date: "2026",
      title: <>Drone Inspection for Solar Panels</>,
      image: Blog_one,
    },
    {
      id: 2,
      date: "2026",
      title: <>Precision Agriculture Using Drones</>,
      image: BlogPost,
    },
  ];

  // Categories
  const categories = [
    { name: "Drone Services", count: 6 },
    { name: "Inspection", count: 5 },
    { name: "Survey & Mapping", count: 5 },
    { name: "Agriculture", count: 4 },
  ];

  // Slider
  const posts = [
    {
      image: Blog_one,
      date: "Aug 23, 2024",
      author: "Admin",
      category: "Developers and Clients",
      title: "Unity Is Still Effective for Developers and Clients...!!",
    },
    {
      image: BlogSubThree,
      date: "Feb 10, 2022",
      author: "Sword Joy",
      category: "Youtube",
      title: "THE UPCOMING WBC CHAMPIONSHIPS 2022 IN FEB",
    },
    // Add more cards if needed
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  // Scroll Up
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <HelmetProvider>
      <Helmet>
        <title>Drone Solutions | SHIV NXTGEN TECHNOLOGIES PRIVATE LIMITED</title>        <meta
          name="description"
          content={
            meta?.meta?.meta1?.content ||
            "Join our real-time internship & training programs with placement support. Learn to build complete projects from scratch."
          }
        />
      </Helmet>
      {/* Banner */}
      <div
        className="position-relative min-vh-50 blog-bg d-flex align-items-center justify-content-center bg-dark text-white"
        style={{ overflowX: "hidden", width: "100%" }}
      >
        <div className="container position-relative px-3 px-md-4">
          <div className="row align-items-center">
            <div className="col-12 blog-content">
              <nav
                aria-label="breadcrumb"
                className="mb-3 mb-md-4"
              // data-aos="fade-right"
              // data-aos-delay="100"
              >
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a
                      href="/"
                      className="text-white fw-bold text-decoration-n"
                    >
                      Home
                    </a>
                  </li>
                  <li className="breadcrumb-item fw-bold" aria-current="page">
                    Drone Solutions
                  </li>
                </ol>
              </nav>
              <h3
                className="display-5 display-md-5 fw-bold mb-3 text-md-start"
              // data-aos="fade-up"
              // data-aos-delay="200"
              >
                Drone Solutions
              </h3>
            </div>
          </div>
        </div>
      </div>

      {/* Top Sections */}
      <div className="container my-5">
        <div className="row g-4">
          {/* Search */}
          <div className="col-lg-4 col-md-6 col-sm-12 d-flex">
            <div className="shadow p-3 rounded-3 bg-white w-100 d-flex flex-column">
              {/* Header */}
              <div className="d-flex align-items-center mb-3">
                <div
                  className="me-3 rounded"
                  style={{
                    width: "4px",
                    height: "25px",
                    background: "#00b7eb",
                  }}
                ></div>
                <h5
                  className="fw-bold font-black mb-0"
                  style={{ fontSize: "20px" }}
                >
                  SEARCH
                </h5>
              </div>
              {/* Content */}
              <InputGroup className="mt-auto">
                <Form.Control
                  type="text"
                  placeholder="Search"
                  className="py-2 px-3"
                  style={{ fontSize: "18px", borderColor: "#e0e0e0" }}
                />
                <InputGroup.Text
                  className="border-start-0"
                  style={{ cursor: "pointer", backgroundColor: "#00b7eb" }}
                >
                  <FaSearch className="text-white" />
                </InputGroup.Text>
              </InputGroup>
            </div>
          </div>

          {/* Categories */}
          <div className="col-lg-4 col-md-6 col-sm-12 d-flex">
            <div className="shadow p-3 rounded-3 bg-white w-100 d-flex flex-column">
              {/* Header */}
              <div className="d-flex align-items-center mb-3">
                <div
                  className="me-3 rounded"
                  style={{
                    width: "4px",
                    height: "25px",
                    background: "#00b7eb",
                  }}
                ></div>
                <h5 className="fw-bold font-black mb-0">CATEGORIES</h5>
              </div>
              {/* Content */}
              <Dropdown className="mt-auto">
                <Dropdown.Toggle
                  variant="light"
                  className="w-100 d-flex justify-content-between align-items-center text-start fw-medium border"
                >
                  <span>Select a Category</span>
                </Dropdown.Toggle>

                <Dropdown.Menu className="w-100">
                  {categories.map((category, index) => (
                    <Dropdown.Item
                      key={index}
                      className="blog-category-item d-flex px-2 align-items-center"
                    >
                      <span className="arrow-icon me-2">
                        <TiArrowRight />
                      </span>
                      <span className="flex-grow-1 fw-semibold text-decoration-none">
                        {category.name}
                      </span>
                      <span className="cou">({category.count})</span>
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>

          {/* Tags */}
          <div className="col-lg-4 col-md-12 col-sm-12 d-flex">
            <div className="shadow p-3 rounded-3 bg-white w-100 d-flex flex-column">
              {/* Header */}
              <div className="d-flex align-items-center mb-3">
                <div
                  className="me-3 rounded"
                  style={{
                    width: "4px",
                    height: "25px",
                    background: "#00b7eb",
                  }}
                ></div>
                <h5 className="fw-bold font-black mb-0">TAGS</h5>
              </div>

              {/* Content */}
              <div className="mt-auto">
                <div className="row g-2">
                  {[
                    "infobpn",
                    "Boxing",
                    "newdriver",
                    "Gallery",
                    "manual",
                    "Office",
                  ].map((tag, index) => (
                    <div key={index} className="col-4 col-md-auto">
                      <span
                        className="tag-hover border rounded-pill px-3 py-1 small bg-white font-black d-inline-block w-100 text-center"
                        style={{
                          transition: "all 0.3s",
                          cursor: "pointer",
                        }}
                      >
                        {tag}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Section */}
      <div className="container mb-5">
        <div className="row">
          {/* SubPage-1 */}
          <div className="col-lg-8">
            <Card className="mx-auto my-3 p-3 rounded-4 h-100 overflow-hidden border-0">
              <div className="position-relative">
                <Image
                  src={BlogSubOne}
                  alt="Game Development"
                  fluid
                  className="w-100 mt-2"
                  style={{
                    objectFit: "cover",
                    borderTopLeftRadius: "0.75rem",
                    borderTopRightRadius: "0.75rem",
                    borderBottomRightRadius: "0.75rem",
                    borderBottomLeftRadius: "0.75rem",
                  }}
                />
                <div className="position-absolute top-0 start-0 bg-red text-white px-3 py-1 m-3 fw-semibold small rounded">
                  Feb 10, 2022
                </div>
              </div>

              <div className="pt-3 pb-2">
                <Row className="align-items-center">
                  <div className="d-flex justify-content-start gap-3">
                    <Col xs="auto" className="text-muted small">
                      <strong>By:</strong>{" "}
                      <span className="fw-semibold text-secondary">Admin</span>
                    </Col>
                    <Col>
                      <span className="text-red fw-semibold text-decoration-none">
                        Developers and Clients
                      </span>
                    </Col>
                  </div>
                </Row>
              </div>

              <Card.Title className="fw-bold fs-4 ms-1 mt-2">
                Aerial Intelligence. Precision. Performance.
              </Card.Title>
              <Card.Text className="ms-1">

                <p className="font-para-blogsub">
                  At SHIV NXTGEN TECHNOLOGIES PRIVATE LIMITED, we deliver advanced drone solutions that transform how industries capture data, monitor assets, and make decisions.
                  From high-precision surveys to cinematic visuals and industrial inspections — we bring intelligence from the sky to your business.
                </p>

                <h5 className="fw-bold mt-4">Overview</h5>
                <p className="font-para-blogsub">
                  Our Drone Division provides end-to-end aerial solutions designed to improve efficiency, reduce operational risks, and deliver highly accurate data.
                </p>

                <h5 className="fw-bold mt-4">Industries We Serve</h5>
                <ul>
                  <li>Energy</li>
                  <li>Construction</li>
                  <li>Power</li>
                  <li>Telecom</li>
                  <li>Agriculture</li>
                  <li>Real Estate</li>
                  <li>Government</li>
                </ul>

                <h5 className="fw-bold mt-4">Inspection Services</h5>
                <ul>
                  <li>Solar Panel Inspection</li>
                  <li>Wind Turbine Inspection</li>
                  <li>Power Line Inspection</li>
                  <li>Telecom Tower Inspection</li>
                  <li>Industrial Inspection</li>
                  <li>Road & Railway Inspection</li>
                </ul>

                <h5 className="fw-bold mt-4">Survey & Mapping</h5>
                <ul>
                  <li>Land Surveying</li>
                  <li>Topographic Mapping</li>
                  <li>GIS Data Collection</li>
                  <li>Construction Mapping</li>
                  <li>Volume & Area Calculation</li>
                </ul>

                <h5 className="fw-bold mt-4">Aerial Cinematography</h5>
                <ul>
                  <li>Real Estate Shoots</li>
                  <li>Promotional Videos</li>
                  <li>Wedding & Event Coverage</li>
                  <li>Corporate Events</li>
                  <li>Aerial Photography</li>
                </ul>

                <h5 className="fw-bold mt-4">Special Activities</h5>
                <ul>
                  <li>Banner Drop</li>
                  <li>Flower Drop</li>
                  <li>Ring / Gift Delivery</li>
                  <li>LED Banner Advertising</li>
                </ul>

                <h5 className="fw-bold mt-4">Agriculture Services</h5>
                <ul>
                  <li>Crop Monitoring</li>
                  <li>Drone Spraying</li>
                  <li>Field Mapping</li>
                  <li>Precision Agriculture</li>
                </ul>

                <h5 className="fw-bold mt-4">Why Choose Us</h5>
                <ul>
                  <li>High-Precision Data</li>
                  <li>Reduced Operational Risk</li>
                  <li>Advanced Drone Technology</li>
                  <li>Industry Expertise</li>
                  <li>End-to-End Solutions</li>
                </ul>

              </Card.Text>

              {/* Slider */}
              <Container className="py-5">
                <h4 className="fw-bold mb-4">RELATED DRONE SERVICES</h4> 
                   <Slider {...settings}>
                  {posts.map((post, idx) => (
                    <Card
                      key={idx}
                      className="border-0 rounded overflow-hidden mx-2"
                    >
                      <div className="position-relative">
                        <Image src={post.image} alt={post.title} fluid />
                        <div className="position-absolute top-0 start-0 bg-red text-white px-3 py-1 m-2 rounded fw-semibold">
                          {post.date}
                        </div>
                      </div>
                      <Card.Body>
                        <div className="d-flex justify-content-start gap-3 small text-muted">
                          <div>
                            <strong>By:</strong> {post.author}
                          </div>
                          <div className="font-red fs-6 fw-semibold">
                            {post.category}
                          </div>
                        </div>
                        <Card.Title className="mt-2 fw-bold text-dark text-uppercase fs-6">
                          <a onClick={navigatePage} id="custom-link">
                            {post.title}
                          </a>
                        </Card.Title>
                      </Card.Body>
                    </Card>
                  ))}
                </Slider>
              </Container>

              {/* Comments */}
              <Container className="my-5">
                <h4 className="fw-bold mb-4 text-uppercase text-dark">
                  Leave a Comment
                </h4>
                <Form className="rounded-4">
                  <Row>
                    <Col md={6} className="mb-4">
                      <Form.Group controlId="formName">
                        <Form.Label className="fw-bold font-red">
                          Your Name*
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter your name"
                          className="rounded-pill border border-dark-subtle"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6} className="mb-4">
                      <Form.Group controlId="formEmail">
                        <Form.Label className="fw-bold font-red">
                          Your Email*
                        </Form.Label>
                        <Form.Control
                          type="email"
                          placeholder="Enter your email"
                          className="rounded-pill border border-dark-subtle"
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Form.Group controlId="formMessage" className="mb-4">
                    <Form.Label className="fw-bold font-red">
                      Your Message*
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={5}
                      placeholder="Write your message here..."
                      className="rounded-3 border border-dark-subtle"
                    />
                  </Form.Group>
                  <div>
                    <span
                      type="submit"
                      className="rounded-pill bg-red border-0 px-4 py-2 fw-semibold d-inline-flex align-items-center text-white"
                    >
                      Submit Now <FaArrowRight className="ms-2" />
                    </span>
                  </div>
                </Form>
              </Container>
            </Card>
          </div>

          {/* Sidebar */}
          <div className="col-lg-4 mt-lg-0">
            {/* Recent Posts */}
            <div
              className="ms-2 mt-4 shadow rounded-3"
              style={{ paddingBottom: "1px" }}
            >
              <div className="d-flex align-items-center mb-3">
                <div
                  className="me-3 rounded"
                  style={{
                    width: "4px",
                    height: "25px",
                    background: "#00b7eb",
                  }}
                ></div>
                <h5 className="fw-bold font-black mb-0">RECENT POST</h5>
              </div>

              <Row className="gx-4 gy-5 p-3">
                {recentPosts.map((post) => (
                  <Col xs={12} md={6} lg={12} key={post.id}>
                    <div className="d-flex align-items-center">
                      <div className="post-hover d-flex align-items-start">
                        <img
                          src={post.image}
                          alt=""
                          className="me-3 rounded post-image"
                          style={{
                            width: "100px",
                            height: "80px",
                            objectFit: "cover",
                          }}
                        />
                        <div>
                          <p className="text-muted small mb-1">{post.date}</p>
                          <h6
                            className="fw-bold font-black lh-sm mb-0 post-title"
                            style={{ fontSize: "15px" }}
                          >
                            {post.title}
                          </h6>
                        </div>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </HelmetProvider>
  );
};

export default BlogSub_1;
